import { useEffect, useRef, useState } from "react";
import { CreateNewScenarioTab } from "@/pages/assistants/AddScenarioPage/CreateNewScenarioTab.tsx";
import { TabList, TabButton, TabsContainer, BackgroundHighlight } from "@/components/ui/Tabs.tsx";
import { Title } from "@/components/ui/Title.ts";
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { IoChevronForward } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/hooks/redux.ts";
import { fetchAssistant } from "@/store/assistantSlice.ts";
import { scenarioApi } from "@/api/scenarios.ts";
import { Scenario } from "@/types/assistants.ts";
import { ImportFromFileTab } from "@/pages/assistants/AddScenarioPage/ImportFromFileTab.tsx";

const tabs = [
    { id: "tab1", label: "Добавление нового", content: <CreateNewScenarioTab /> },
    { id: "tab2", label: "Импорт из файла", content: <ImportFromFileTab /> },
];

export const AddScenarioPage = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [scenario, setScenario] = useState<Scenario | undefined>();
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 });
    const { id, scenarioId } = useParams();
    const { assistant } = useAppSelector(state => state.assistant);
    const dispatch = useAppDispatch();
    const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);
    const highlightRef = useRef<HTMLDivElement | null>(null);

    const handleTabClick = (id: string) => {
        if(highlightRef.current) {
            highlightRef.current.style.transition = 'transform 0.3s ease-in-out, width 0.3s ease-in-out'
        }
        setActiveTab(id);
        const activeIndex = tabs.findIndex((tab) => tab.id === id);
        const button = tabRefs.current[activeIndex];
        if (button) {
            setHighlightStyle({
                left: button.offsetLeft,
                width: button.offsetWidth,
            });
        }
    };

    useEffect(() => {
        const activeIndex = tabs.findIndex((tab) => tab.id === activeTab);
        const button = tabRefs.current[activeIndex];
        if (button) {
            setHighlightStyle({
                left: button.offsetLeft,
                width: button.offsetWidth,
            });
        }
    }, []);

    useEffect(() => {
        if (scenarioId) {
            scenarioApi.getOne(parseInt(scenarioId)).then((res) => {
                setScenario(res.data)
            });
        }
    }, [scenarioId]);

    useEffect(() => {
        dispatch(fetchAssistant(Number(id)))
    }, [id]);

    return (
        <div style={{ maxWidth: '635px' }}>
            <Title style={{ marginBottom: '1.2rem' }}>{scenarioId ? 'Редактировать сценарий' : 'Добавить сценарий'}</Title>
            <Breadcrumbs>
                <a href="/dashboard/assistants">Мои ассистенты</a>
                <IoChevronForward size={14} color="#000000"/>
                <a href={`/dashboard/assistants/${id}/scenarios`}>{assistant?.Name}</a>
                <IoChevronForward size={14} color="#000000"/>
                {scenario?.Name && (
                    <>
                        <a href={`/dashboard/assistants/${id}/scenarios/${scenarioId}/steps`}>{scenario?.Name}</a>
                        <IoChevronForward size={14} color="#000000"/>
                    </>
                )}
                <span>{scenarioId ? 'Редактировать сценарий' : 'Добавить сценарий'}</span>
            </Breadcrumbs>
            {scenarioId ? <CreateNewScenarioTab scenario={scenario} /> : (
                <div>
                    <TabsContainer>
                        <TabList>
                            <BackgroundHighlight ref={highlightRef} left={highlightStyle.left} width={highlightStyle.width} />
                            {tabs.map((tab, index) => (
                                <TabButton
                                    key={tab.id}
                                    active={activeTab === tab.id}
                                    onClick={() => handleTabClick(tab.id)}
                                    ref={(el) => (tabRefs.current[index] = el)}
                                >
                                    {tab.label}
                                </TabButton>
                            ))}
                        </TabList>
                    </TabsContainer>
                    <div>
                        {tabs.find((tab) => tab.id === activeTab)?.content}
                    </div>
                </div>
            )}
        </div>
    );
};
